/** Development – dev.api (same target as production for now) */
export const environment = {
  production: false,
  apiUrl: 'https://dev.api.easywy.com/api',
  apiBaseUrl: 'https://dev.api.easywy.com',
  googleClientId: '950488528602-nsgk8qli5vgt1snoct75vvhl66vlgejv.apps.googleusercontent.com',
  googleClientIdMobile: '950488528602-cral82lulm0iglobch1obu1j03u9lg36.apps.googleusercontent.com',
  facebookAppId: '539129806165437',
  appVersion: '1.0.0',
};


